// @flow
import React from 'react';
import { I18n } from '@lingui/react';

import Select from '@rover/react-lib/components/formFields/Select';
import unitedStates from '@rover/react-lib/constants/unitedStates.constants';

export type Props = {
  value: string,
  onChange: string => void,
  validationError: ?string,
};

export default (props: Props) => (
  <I18n>
    {({ i18n }) => (
      <Select
        name="zipcode"
        placeholder={i18n._('State')}
        autoComplete="address-level1"
        options={unitedStates.map(s => ({
          value: s.code,
          title: s.code,
        }))}
        {...props}
      />
    )}
  </I18n>
);



// WEBPACK FOOTER //
// ../react-lib/src/components/formFields/StateInput/StateInput.jsx